<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <Cascader
      style="width: 100%;"
      :value="value"
      :data="renderValues"
      :clearable="clearable"
      :filterable="filterable"
      :loading="isLoading"
      :load-data="loadItems"
      :size="size || $size"
      transfer
      @on-change="onInputChange"
      @on-visible-change="reload"
    ></Cascader>
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'
import queryMixin from './mixins/query'
import valueTextMixin from './mixins/value-text'

export default {
  name: 'zpaCascader',

  mixins: [
    inputMixin,
    queryMixin,
    valueTextMixin,
  ],

  data() {
    return {
      vType: 'array',
    }
  },

  props: {
    queryItems: {
      type: Function,
      required: true,
    },

    hasSwitch: Boolean,

    value: Array,

    values: Array,

    multiple: Boolean,

    clearable: Boolean,

    filterable: Boolean,

    textField: {
      type: String,
      default: 'label',
    },

    itemValueField: {
      type: String,
      default: 'value',
    },

    itemTextField: {
      type: String,
      default: 'label',
    },
  },

  methods: {
    checkValues(values) {
      if (!values) return

      values.forEach(v => {
        v.value = this.valueField ? v[this.valueField] : v.value
        v.label = this.textField ? v[this.textField] : v.label
        this.$set(v, 'loading', false)
        this.$nextTick(() => {
          v.children = v.children || []
        })
      })
    },

    checkItemValues(values) {
      if (!values) return

      values.forEach(v => {
        v.value = this.itemValueField ? v[this.itemValueField] : v.value
        v.label = this.itemTextField ? v[this.itemTextField] : v.label
      })
    },

    async reload() {
      if (this.query) {
        this.isLoading = true
        this.renderValues = await this.query() || this.renderValues
        this.checkValues(this.renderValues)
        this.isLoading = false
      }
    },

    async loadItems(item, next) {
      item.loading = true
      item.children = await this.queryItems(item.value) || []
      this.checkItemValues(item.children)
      item.loading = false
      next()
    },
  },

  watch: {
    values: {
      handler(values) {
        if (values) {
          this.renderValues = values
          this.checkValues(this.renderValues)
        }
      },
      immediate: true,
    },
  },
}
</script>
